class CreditCard {
  constructor(
    id,
    type,
    number,
    expireMonth,
    expireYear,
    createdAt,
    updatedAt
  ) {
    this.id = id
    this.type = type
    this.number = number
    this.expireMonth = expireMonth
    this.expireYear = expireYear
    this.createdAt = createdAt
    this.updatedAt = updatedAt
  }

  info() {
    return this.number + ' ' + CardType[this.type] + ' ' + this.expireDate()
  }

  expireDate() {
    if (this.expireMonth < 10) {
      return "0" + this.expireMonth + "/" + this.expireYear.slice(2)
    } else {
      return this.expireMonth + "/" + this.expireYear.slice(2)
    }
  }
}

const CardType = {
  'visa': 'VISA',
  'mastercard': 'Mastercard',
  'amex': 'Amex',
  'discover': 'Discover',
  'maestro': 'Maestro'
}

Object.freeze(CardType)


export { CreditCard }